import axios from "axios";

export const state = {
    nurserysubjects: [],
};

export const getters = {
    nurserysubjects: state => state.nurserysubjects,
};

export const mutations = {
    setNurserySubject(state, newValue) {
        state.nurserysubjects = newValue
    },
};

export const actions = {
    fetchNurserySubjects({ commit }) {
        axios.get('/nurserysubjects').then(res => {
            commit('setNurserySubject', res.data.nurserysubjects);
        })
    },
};
